<template>
  <div class="list-box" style="padding: 0; padding-top: 10px">
    <ul class="list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column prop="msg" label="发放类型" min-width="180">
          <template #default="{ row }">
            <c_status arrName="salaryrecord_type" :value="row.pay_type" />
          </template>
        </el-table-column>
        <el-table-column label="是否对接银企" min-width="180">
          <template #default="{ row }">
            {{ row.is_interface ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column label="银企类型" min-width="120">
          <template #default="{ row }">
            <c_status arrName="b2e_type" :value="row.b2e_type" />
          </template>
        </el-table-column>
        <el-table-column
          sortable="create_time"
          prop="create_time"
          label="操作时间"
          :formatter="$tab_TextFormat"
          show-overflow-tooltip
          min-width="180"
        />
        <el-table-column
          label="操作"
          width="360"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row, $index }">
            <el-button
              type="primary"
              link
              icon="Search"
              @click="
                state.selectIndex = $index;
                state.selectItem = row;
                state.showFiles = true;
              "
            >
              查看附件
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
  <el-dialog
    v-model="state.showFiles"
    title="查看附件"
    width="50%"
    align-center
  >
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 10px;
      "
    >
      <el-button
        type="primary"
        @click="
          state.files = [];
          state.uploadModel = {};
          state.showDone = true;
        "
        >上传</el-button
      >
      <el-button type="danger" @click="onDelete">删除</el-button>
    </div>
    <el-table
      :data="state.selectItem?.log_attachment"
      style="width: 100%; border: 0"
      ref="fileTableDom"
      @row-click="onRowClick"
      :key="state.key"
      v-if="state.showFiles"
    >
      <el-table-column type="selection" width="55" fixed />
      <el-table-column
        fixed
        label="序号"
        width="70"
        type="index"
        align="center"
      />
      <el-table-column
        label="文件名称"
        prop="filename"
        :formatter="$tab_TextFormat"
        min-width="220"
      />
      <el-table-column
        label="操作"
        :width="220"
        align="center"
        fixed="right"
        className="tabBtn"
      >
        <template #default="{ row }">
          <el-button
            type="primary"
            link
            icon="Download"
            @click.stop="onDownLoad(row)"
          >
            下载
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
  <el-dialog v-model="state.showDone" title="上传附件" width="500" align-center>
    <el-form
      :model="state.uploadModel"
      ref="uploadDom"
      label-width="auto"
      label-position="top"
    >
      <el-form-item
        label="附件"
        prop="attachment_id"
        :rules="[
          {
            required: true,
            message: '请上传附件',
            trigger: 'blur',
          },
        ]"
        style="position: relative"
      >
        <el-upload
          :show-file-list="false"
          :auto-upload="false"
          :multiple="true"
          accept=".jpeg,.jpg,.png,.gif"
          :on-change="onChangeFile"
          style="position: absolute; right: 0; top: -40px"
        >
          <template #trigger>
            <el-button type="warning" size="small">选择文件</el-button>
          </template>
        </el-upload>
        <div>
          <ul
            v-for="(item, index) in state.files"
            :key="item"
            style="display: flex; align-items: center; line-height: 30px"
          >
            <el-icon><Document /></el-icon>
            <li
              style="flex: 1; overflow: hidden; height: 30px; margin-left: 5px"
            >
              {{ item.filename }}
            </li>
            <el-button
              link
              icon="delete"
              type="danger"
              size="large"
              @click="
                state.files.splice(index, 1);
                state.uploadModel.attachment_id = (state.files || [])
                  .map((m) => m.id)
                  .join(',');
              "
            ></el-button>
          </ul>
        </div>
      </el-form-item>
      <el-form-item label="附件说明" prop="desc">
        <el-input
          v-model="state.uploadModel.attachment_remark"
          type="textarea"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="state.showDone = false">取消</el-button>
        <el-button type="primary" @click="onSubmitDone">提交</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  salarypayment_log,
  salarypayment_log_upload,
  salarypayment_log_donwload,
  salarypayment_delsftpfile,
} from "@/http/salarypayment";
import { attachment_upload } from "@/http/attachment";
import { ElMessage, ElMessageBox } from "element-plus";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
  };
}
export default {
  props: {
    id: Number,
  },
  setup(props) {
    const fileTableDom = ref(null);
    const uploadDom = ref(null);

    const state = reactive({
      ...new InitFormData(),
      files: [],
      uploadModel: {},
    });
    onMounted(() => {
      state.params.salary_record_id = props.id;
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      salarypayment_log(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;

          state.tableData = list;
          state.totalCount = count;
          if (state.selectIndex >= 0)
            state.selectItem = list[state.selectIndex];
        }
      });
    };

    const onChangeFile = (file) => {
      const formData = new FormData();
      formData.append("file[]", file.raw);
      attachment_upload(formData).then((res) => {
        if (res.status == 200) {
          res.data.data.forEach((e) => {
            state.files.push(e);
          });
          state.uploadModel.attachment_id = state.files
            .map((m) => m.id)
            .join(",");
        }
      });
    };

    const onSubmitDone = () => {
      uploadDom.value.validate((valid) => {
        if (valid) {
          salarypayment_log_upload({
            salary_record_log_id: state.selectItem?.id,
            attachment_id: state.uploadModel.attachment_id,
            attachment_remark: state.uploadModel.attachment_remark,
          }).then((res) => {
            if (res.status == 200) {
              ElMessage.success(res.data.msg);
              onLoad();
              state.showDone = false;
            }
          });
        }
      });
    };

    const onDownLoad = (row) => {
      salarypayment_log_donwload({
        salary_record_log_id: state.selectItem?.id,
        id: row.id,
      })
        .then((res) => {
          if (res.status == 200) {
            let fileName = decodeURI(
              res.headers["content-disposition"].split("=")[1],
            );

            //通过后台返回 的word文件流设置文件名并下载
            var blob = new Blob([res.data], {
              type: res.data.type,
            });
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
          }
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8",
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //表格行点击事件
    const onRowClick = (row) => {
      fileTableDom.value.toggleRowSelection(row);
    };

    const onDelete = () => {
      const rows = fileTableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要删除的附件",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您确定将已选的<strong style='color:#1e90ff'>${rows.length}</strong>个附件<strong style='color:#f00'>删除</strong>吗？`,
        "删除确认",
        {
          confirmButtonText: "确定删除",
          confirmButtonClass: "el-button--danger",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        },
      ).then(() => {
        const data = {
          salary_record_log_id: state.selectItem?.id,
          id: rows.map((m) => m.id).join(","),
        };
        salarypayment_delsftpfile(data).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    return {
      state,
      onLoad,
      onDownLoad,
      onSortChange,
      onChangeFile,
      onSubmitDone,
      uploadDom,
      onRowClick,
      onDelete,
      fileTableDom,
    };
  },
};
</script>
<style scoped></style>
